export const REMOVE_LABEL_FROM_ARTICLE_FAILURE =
	'state.actions.remove-label-from-article-failure.REMOVE_LABEL_FROM_ARTICLE_FAILURE';

export type RemoveLabelFromArticleFailurePayload = {
	articleId: string;
};

export type RemoveLabelFromArticleFailureAction = {
	type: typeof REMOVE_LABEL_FROM_ARTICLE_FAILURE;
	payload: RemoveLabelFromArticleFailurePayload;
};

export const removeLabelFromArticleFailure = (
	payload: RemoveLabelFromArticleFailurePayload,
): RemoveLabelFromArticleFailureAction => ({
	payload,
	type: REMOVE_LABEL_FROM_ARTICLE_FAILURE,
});
